const steps = [
  {
    id: 1,
    title: 'Register',
    text: "Create your plasma account in less than 2 minutes. It's free for everybody.",
    icon: 'fa-regular fa-plus',
  },
  {
    id: 2,
    title: 'Complete your account',
    text: 'Fill your profile information to start using the platform and to interact with others.',
    icon: 'fa-regular fa-user',
  },
  {
    id: 3,
    title: 'Make blood Requests',
    text: 'Create new blood requests matching your needs in a matter of seconds.',
    icon: 'fa-solid fa-droplet',
  },
  {
    id: 4,
    title: 'Find Blood',
    text: 'Browse our donors and organization database to find what you need.',
    icon: 'fa-solid fa-magnifying-glass',
  },
  {
    id: 5,
    title: 'View pending Requests',
    text: 'Track existing blood requests and get updated in real time.',
    icon: 'fa-regular fa-eye',
  },
  {
    id: 6,
    title: 'Share and Save Lives',
    text: 'Make announcements, invite friends or share pending requests. Help saving more Lives!',
    icon: 'fa-solid fa-share',
  },
]

export default steps
